module.exports = __webpack_public_path__ + "img/21.86a2c040.png";